import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Form, Errors, actions, Control} from 'react-redux-form';
import {FormGroup, FormControl, ControlLabel, Grid, Row, Col, Radio, Button} from 'react-bootstrap';
import EmailMessage from './email-message-editor';
import SMSMessage from './sms-message-editor';
import SiteMessage from './site-message-editor';
import BackLink from '../../../common/back-link/index'
import PageTitle from "../../../common/page-title/index";
import ArrowButton from "../../../common/button-arrow";
import {getNotification, getNewNotificationPins, saveNotification, updateNotification} from '../../../../actions/notifications'

import './styles.css'
import RequiredSelect from '../../../common/form/elements/required-select';

class Notification extends Component {
  constructor(props) {
    super(props);

    let title = 'ADD NOTIFICATION';
    if (+this.props.match.params.id) {
      title = 'EDIT NOTIFICATION';
    }

    this.state = {
      to_associated_user: true,
      title: title,
      id: +this.props.match.params.id,
      eventList: ''
    };
  }

  onSubmit = (payLoad) => {
    if (this.state.id) {
      this.props.dispatch(actions.submitFields('deep.admin_notification_edit', updateNotification(this.state.id, payLoad)));
    } else {
      this.props.dispatch(actions.submitFields('deep.admin_notification_edit', saveNotification(payLoad)));
    }
  };

  componentWillMount() {
    if (this.state.id) {
      this.props.dispatch(getNotification(this.state.id));
    } else {
      // get new notif pins
      this.props.dispatch(getNewNotificationPins());
    }
    this.props.dispatch(actions.reset('deep.admin_notification_edit'));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_notification_edit'));
  }

  render() {
    const eventList = [{
      label: '[event]',
      value: ''
    }];

    Object.keys(this.props.pins).forEach((eventID) => {
      eventList.push({
        label: this.props.pins[eventID],
        value: eventID
      })
    });

    return (
      <Grid bsClass="container" fluid className="notification">
        <Row>
          <Col md={12}>
            <BackLink href="/admin/notifications"/>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PageTitle>{this.state.title}</PageTitle>
          </Col>
        </Row>
        <Form model="deep.admin_notification_edit"
              onChange={() => { this.props.dispatch(actions.resetValidity('deep.admin_notification_edit')) }}
              onSubmit={(payload) => this.onSubmit(payload)}>
          <Row>
            <Col md={12}>
              <RequiredSelect model=".event"
                              values={eventList}
                              label="Event"
                              controlId="event"
                              hasEmptyValue={false}/>

              <FormGroup controlId="to_associated_user">
                <div>
                  <ControlLabel>Recipient*</ControlLabel>
                </div>
                <Row>
                  <Col md={12}>
                    <Control.radio model=".to_associated_user"
                                   value="true"
                                   component={Radio}>Associated user</Control.radio>
                  </Col>
                </Row>
                <Row>
                  <Col md={2}>
                    <Control.radio model=".to_associated_user"
                                   value="false"
                                   component={Radio}>Custom To</Control.radio>
                  </Col>
                  <Col md={10}>
                    <FormGroup controlId="custom-to">
                      <Control.textarea
                        model=".custom_to"
                        disabled={this.props.to_associated_user === "true"}
                        rows="1"
                        className="form-control"/>

                      <Errors
                        show={{
                          touched: true,
                          focus: false
                        }}
                        className="errors"
                        model=".custom_to"/>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <EmailMessage />
                    <SMSMessage />
                    <SiteMessage />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <ArrowButton color="grey"
                                 className="pull-right">Save</ArrowButton>
                  </Col>
                </Row>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    to_associated_user: state.deep.admin_notification_edit.to_associated_user,
    pins: state.notifications.pins
  };
};


export default connect(mapStateToProps)(Notification);



// WEBPACK FOOTER //
// ./src/components/admin/notifications/edit/index.jsx